export default __webpack_public_path__ + "static/media/User_add_light.4448b24e.svg";